export * from './bericht-gespeichert.interface';
